import {
  ChoiceDto,
  MessageRequestDTO,
  StepDTO,
  SurveyAnswerDTO,
  SurveyAnswerRequestDTO,
  SurveyDTO,
} from "../api/Api";
import { API } from "../config/api";

class FeedbackService {
  async sendFeedback(message: MessageRequestDTO) {
    try {
      let res = API.api.sendMessage(message);
      let result = (await res).data;
      return 200;
    } catch (err: any) {
      console.error(err);
      return 500;
    }
  }

  async getQuestion() {
    try {
      let res = API.api.getSurveyQuestion();
      let result = (await res).data as unknown as SurveyDTO;
     

      return result;
    } catch (err: any) {
      console.error(err);
      return {};
    }
  }

  async sendAnswer(answer: SurveyAnswerRequestDTO) {
    try {
      let res = API.api.sendSurveyAnswer(answer);
      let result = (await res).data;
      return 200;
    } catch (err: any) {
      console.error(err);
      return 500;
    }
  }
}

export const feedbackService: FeedbackService = new FeedbackService();
